/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
  isLoading: false,
  error: false,
  rootCategories: [],
  currentRootCategory: {},
  tmpRootCategory: {},

  expanded: [],
  selected: [],
  paths: []
};

const slice = createSlice({
  name: 'category',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getRootCategoriesSuccess(state, action) {
      state.isLoading = false;
      state.rootCategories = action.payload;
    },
    setCurrentRootCategorySuccess(state, action) {
      state.currentRootCategory = action.payload;
      state.tmpRootCategory = action.payload;
    },
    createCategorySuccess(state, action) {
      state.currentRootCategory = action.payload.root;
      state.expanded.push(action.payload.node._id);
      state.expanded.push(action.payload.node.parent);
    },
    updateCategorySuccess(state, action) {
      state.currentRootCategory = action.payload.root;
    },
    deleteCategorySuccess(state, action) {
      state.currentRootCategory = action.payload.root;
    },
    moveCategorySuccess(state, action) {
      state.currentRootCategory = action.payload.root;
    },
    setExpandedSuccess(state, action) {
      console.log('payload', action.payload);
      state.expanded = action.payload;
    },
    addToSelectedSuccess(state, action) {
      state.selected = [...state.selected, action.payload];
      console.log(state.selected);
    },
    removeFromSelectedSuccess(state, action) {
      const tmp = state.selected.filter((item) => item !== action.payload);
      state.selected = tmp;
      console.log(state.selected);
    },
    setSelectedSuccess(state, action) {
      state.selected = action.payload;
    },
    setProductCatalogCategorySuccess(state, action) {
      state.isLoading = false;
    },
    getProductCatalogCategorySuccess(state, action) {
      state.isLoading = false;
      console.log(action.payload);
      state.selected = action.payload;
    }
  }
});

export default slice.reducer;

export function getRootCategories() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/categories/root');
      dispatch(slice.actions.getRootCategoriesSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function setCurrentRootCategory(id) {
  return async (dispatch) => {
    const response = await axios.get(`/categories/${id}`);
    console.log(response.data);
    dispatch(slice.actions.setCurrentRootCategorySuccess(response.data));
  };
}

export function createCategory(currentRootId, parentId, name) {
  return async (dispatch) => {
    const response = await axios.post(`/categories/${parentId}/create`, { name, rootCategoryId: currentRootId });
    console.log(response.data);
    dispatch(slice.actions.createCategorySuccess(response.data));
  };
}

export function deleteCategory(currentRootId, parentId) {
  return async (dispatch) => {
    const response = await axios.delete(`/categories/${parentId}/${currentRootId}`);
    console.log(response.data);
    dispatch(slice.actions.deleteCategorySuccess(response.data));
  };
}

export function updateCategory(currentRootId, categoryId, name, attachedData) {
  return async (dispatch) => {
    const response = await axios.post(`/categories/${categoryId}`, {
      name,
      attachedData,
      rootCategoryId: currentRootId
    });
    console.log(response.data);
    dispatch(slice.actions.updateCategorySuccess(response.data));
  };
}

export function moveCategory(currentRootId, fromId, toId) {
  return async (dispatch) => {
    const response = await axios.post(`/categories/${fromId}/to/${toId}`, { rootCategoryId: currentRootId });
    console.log(response.data);
    dispatch(slice.actions.moveCategorySuccess(response.data));
  };
}

export function setExpanded(nodeIds) {
  return async (dispatch) => {
    console.log(nodeIds);
    dispatch(slice.actions.setExpandedSuccess(nodeIds));
  };
}

export function addToSelected(nodeId) {
  return async (dispatch) => {
    dispatch(slice.actions.addToSelectedSuccess(nodeId));
  };
}

export function removeFromSelected(nodeId) {
  return async (dispatch) => {
    dispatch(slice.actions.removeFromSelectedSuccess(nodeId));
  };
}

export function setSelected(selection) {
  return async (dispatch) => {
    dispatch(slice.actions.setSelectedSuccess(selection));
  };
}

export function setProductCatalogCategory(customProductId, catalogId, categoryIds) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`/products/${customProductId}/setCategory`, {
        catalogId,
        categoryIds
      });
      dispatch(slice.actions.setProductCatalogCategorySuccess(response));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getProductCatalogCategory(customProductId, catalogId) {
  return async (dispatch) => {
    const response = await axios.post(`/products/${customProductId}/getCategory/${catalogId}`, {});
    console.log(response.data);
    dispatch(slice.actions.setProductCatalogCategorySuccess(response.data));
  };
}
